module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/780de411d1edba8c02b28080fd054c35.png";